import { useQuery } from "@apollo/client";
import { VERIFY_USER_QUERY } from "../../graphql/queries/user.queries";

const useValidateToken = () => {
  const { data, loading, error } = useQuery(
    VERIFY_USER_QUERY,
    { variables: { token: localStorage.getItem("token") } },
    {
      fetchPolicy: "network-only",
    }
  );

  return {
    data,
    loading,
    error,
  };
};

export default useValidateToken;
